import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-color-picker-square',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './color-picker-square.component.html',
  styleUrl: './color-picker-square.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPickerSquareComponent {
  @Input({ required: true }) formGroup!: FormGroup | UntypedFormGroup;
  @Input({ required: true }) controlName!: string;
  @Input() label?: string;
  @Input() hint?: string;
  @Input() ariaLabel?: string;
  @Input() inputId?: string;
}